import { TcrUseCase } from '@servicetitan/application-data/dist/squads/telecom';

export const getMessagingValueToShow = (useCases?: TcrUseCase[]) => {
    if (useCases?.includes(TcrUseCase.MARKETING)) {
        return 'Marketing';
    }

    if (useCases?.includes(TcrUseCase.MIXED)) {
        return 'Default';
    }

    return '-';
};
